(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  define('commons/views/EditorialScheduleView',["jquery", "backbone", "underscore", "commons/views/SlideView", "commons/models/Lightbox", "hbs!commons/templates/editorialschedule-wrapper", "hbs!commons/templates/editorialschedule", "jquery-ui", "jquery-datepicker", "jquery-ui.multi"], function($, Backbone, _, SlideView, Lightbox, wrapperHbs, scheduleHbs) {
    return (function(superClass) {
      extend(_Class, superClass);

      function _Class() {
        return _Class.__super__.constructor.apply(this, arguments);
      }

      _Class.prototype.initialize = function() {
        this.isInitialSetup = true;
        this.model = new Lightbox({
          id: this.options.id,
          url: this.options.url
        });
        this.bindings();
        this.append();
        return this.mediaId = $("#container").data("mediaid");
      };

      _Class.prototype.bindings = function() {
        this.model.on("change:isOpen", this.toggle);
        return this.model.on("change:content", this.updateContent);
      };

      _Class.prototype.events = {
        "change .editorialschedule-select": "onChangeSchedule"
      };

      _Class.prototype.show = function() {
        return $.ajax({
          url: "/Advertising/Print/EditorialSchedules/" + this.mediaId
        }).done((function(_this) {
          return function(resp) {
            _this.content(wrapperHbs({
              editorialschedules: resp
            }));
            return _this.$(".editorialschedule-select").change();
          };
        })(this));
      };

      _Class.prototype.onChangeSchedule = function(event) {
        return $.ajax({
          url: "/Advertising/Print/Editorial/" + event.currentTarget.value
        }).done((function(_this) {
          return function(resp) {
            return _this.$(".editorialschedule").html(scheduleHbs(resp));
          };
        })(this));
      };

      return _Class;

    })(SlideView);
  });

}).call(this);

//# sourceMappingURL=EditorialScheduleView.js.map
;
